import './Loader.less';
import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import classNames from 'classnames';

interface LoaderProps {
    full?: boolean;
    [key: string]: any;
}

export default Loader;

/**
 * @name Loader
 * @desc Loader component: displays a loading icon.
 */
function Loader({ full, ...rest }: LoaderProps) {
    return (
        <div
            className={classNames('Loader', {
                'Loader-full': full,
            })}
            {...rest}
        >
            <LoadingOutlined
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
            />
        </div>
    );
}
